import { Component, effect, EventEmitter, inject, Input, Output } from '@angular/core';
import { OpenQuoteRequestsItem } from '../quote-requests.types';
import { NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { FuseDrawerModule } from '@fuse/components/drawer';
import {
  PurchaseStepsWrapperComponent,
} from '@sbd-account-portal/app/modules/dashboard/open-quote-requests-widget/purchase-steps/purchase-steps-wrapper/purchase-steps-wrapper.component';
import {
  OpenQuoteRequestListViewComponent,
} from '@sbd-account-portal/app/modules/dashboard/open-quote-requests-widget/purchase-steps/steps/open-quote-request-list-view/open-quote-request-list-view.component';
import {
  DeliveryDetailsComponent,
} from '@sbd-account-portal/app/modules/dashboard/open-quote-requests-widget/purchase-steps/steps/delivery-details/delivery-details.component';
import {
  PaymentDetailsComponent,
} from '@sbd-account-portal/app/modules/dashboard/open-quote-requests-widget/purchase-steps/steps/payment-details/payment-details.component';
import {
  CheckoutPageComponent,
} from '@sbd-account-portal/app/modules/dashboard/open-quote-requests-widget/purchase-steps/steps/checkout-page/checkout-page.component';
import {
  PurchaseConfirmationPageViewComponent,
} from '@sbd-account-portal/app/modules/dashboard/open-quote-requests-widget/purchase-steps/steps/purchase-confirmation-page-view/purchase-confirmation-page-view.component';
import { User } from '@sbd-account-portal/app/core/user/user.types';
import { UntypedFormGroup } from '@angular/forms';
import { MainFuseDrawerService } from '@sbd-account-portal/app/modules/main-fuse-drawer/main-fuse-drawer.service';

@Component({
  selector: 'sbd-account-portal-frontend-purchase-steps',
  standalone: true,
  imports: [
    NgSwitchCase,
    NgSwitch,
    NgIf,
    FuseDrawerModule,
    PurchaseStepsWrapperComponent,
    OpenQuoteRequestListViewComponent,
    DeliveryDetailsComponent,
    PaymentDetailsComponent,
    CheckoutPageComponent,
    PurchaseConfirmationPageViewComponent,
  ],
  templateUrl: './purchase-steps.component.html',
})
export class PurchaseStepsComponent {
  @Input() selectedQR: OpenQuoteRequestsItem | null = null;
  @Input() step: number = -1;
  @Input() activeOpenedQR: any = {};
  @Input() isPurchasing: boolean = false;
  @Input() checkoutForm: UntypedFormGroup;
  @Input() loggedInAccountUser: User;
  @Input() recentlyPurchasedCount: number = 0;

  @Output() closeDrawerEvent = new EventEmitter<void>();
  @Output() updatedOpenQREvent = new EventEmitter<OpenQuoteRequestsItem>();
  @Output() moveBackEvent = new EventEmitter<void>();
  @Output() getShippingMethodValueEvent = new EventEmitter<{ event: any, key: string, index: number }>();
  @Output() moveToNextStepEvent = new EventEmitter<void>();
  @Input() showCloseButton!: boolean;

  shippingTotal: number = 0;
  total: number = 0;
  subtotal: number = 0;
  isPurchased: boolean = false;
  queuedQR: OpenQuoteRequestsItem[] = [];

  _mainFuseDrawerService = inject(MainFuseDrawerService);

  constructor() {
    effect(() => {
      this.isPurchased = this._mainFuseDrawerService.isPurchased();
      this.recentlyPurchasedCount = this._mainFuseDrawerService.recentlyPurchasedCount();
      this.shippingTotal = this._mainFuseDrawerService.shippingTotal();
      this.subtotal = this._mainFuseDrawerService.subtotal();
      this.total = this._mainFuseDrawerService.total();
      this.queuedQR = this._mainFuseDrawerService.queuedQR();
    });
  }

  onCloseDrawer() {
    this.closeDrawerEvent.emit();
  }

  onUpdateSelectedQuoteOption(event: OpenQuoteRequestsItem) {
    this.updatedOpenQREvent.emit(event);
  }

  onMoveBack() {
    this.moveBackEvent.emit();
  }

  onGetShippingMethodValue(data: { event: any, key: string, index: number }) {
    this.getShippingMethodValueEvent.emit(data);
  }

  onMoveToNextStep() {
    this.moveToNextStepEvent.emit();
  }
}
